<div
  [style.border]="itemStyle().card.border"
  class="card {{ dataService.currentPage() }}"
  [style.boxShadow]="itemStyle().card.boxShadow"
  [style.background]="itemStyle().card.background"
  [style.borderRadius]="itemStyle().card.borderRadius"
>
  @let picture = stepContent().picture;
  <img
    class="step-img"
    [src]="picture.imageUrl"
    [alt]="picture.alternativeText | replaceVars: maxSelectedChallenges"
  />
  <div class="card-body">
    @let titleStyles = itemStyle().title;
    <p
      class="card-title"
      [style.color]="titleStyles.color"
      [style.fontFamily]="titleStyles.fontFamily"
    >
      {{ stepContent().title }}
    </p>
  </div>
</div>
